<mat-toolbar color="primary">
  <button
    mat-icon-button
    (click)="toggleRightSidenav()">
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>

  <!-- <div class="currentPage" [innerHTML]="currentPageTitle"></div> -->

  <div class="left-container">
    <!-- <h2>Facilis.aero AIM</h2> -->
     <h2>{{ appTitle }}</h2>
    <span>|</span>
    <span>{{ tenantDisplayName }}</span>
    <!-- Facilis.aero AIM (beta version: not for operatonal use) -->
  </div>

  <span class="spacer"></span>

  <div class="right-container">
    <!-- App status -->
    @if (appStatus()) {
    <button
      class="mat-elevation-z0 status-btn"
      mat-flat-button
      [matTooltip]="appStatus()?.tooltipMessage"
      color="primary">
      <span
        class="indicator"
        [class]="appStatus()?.status"
        >{{ appStatus()?.label }}
      </span>
    </button>
    }

    <!-- Username -->
    <div class="username-section">
      {{ username }}
    </div>

    <div class="button-menu-group">
      <!-- Help Button -->
      <button
        mat-icon-button
        [matMenuTriggerFor]="helpMenu"
        matTooltip="Help">
        <mat-icon>help</mat-icon>
      </button>
      <mat-menu #helpMenu="matMenu">
        <button
          mat-menu-item
          (click)="openHelp()">
          Help
        </button>
        <button
          mat-menu-item
          onclick="window.open('https://forum.facilis.aero/')">
          Forum
        </button>
      </mat-menu>

      <!-- Settings button -->
      <button
        mat-icon-button
        [matMenuTriggerFor]="settingMenu"
        matTooltip="Settings">
        <mat-icon>settings</mat-icon>
      </button>

      <mat-menu #settingMenu="matMenu">
        <button
          mat-menu-item
          [routerLink]="'/datastore'"
          *ngIf="hasFOModuleRole()">
          Switch datastore
        </button>
        <button
          mat-menu-item
          [routerLink]="'/user-settings'"
          *ngIf="hasFOModuleRole()">
          User Settings
        </button>
        <button
          mat-menu-item
          [routerLink]="'/datastore-settings'"
          *ngIf="hasAdminRole()">
          Datastore Settings
        </button>
        <button
          mat-menu-item
          [routerLink]="'/about'">
          About
        </button>
      </mat-menu>

      <!-- Account -->
      <button
        type="button"
        mat-icon-button
        [matMenuTriggerFor]="userMenu"
        matTooltip="Account">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button
          mat-menu-item
          [routerLink]="'/account-management'">
          Account
        </button>
        <button
          mat-menu-item
          (click)="logout()">
          Logout
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
